import { AgentDetailContractSubScope, AgentDetailSectionEnum } from "./agentDetail.model";
import { AgentsFilters, IAgentsCountWithSegregationResp, IAgentsPermissionResp } from "./agents.model";

export const USER_TYPE_KEY = "userType";
export const AGENCY_NAME_KEY = "agencyName";
export const AGENT_NAME_KEY = "agentName";

export const DEFAULT_AGENTS_FILTERS: AgentsFilters = {
    userType: [],
    agencyName: [],
    agentName: [],
};

export enum AgentsTblKeys {
    NAME = "name",
    EMAIL = "email",
    CELL_NUMBER = "cellNumber",
    USER_TYPE = "userType",
    BUSINESS_NAME = "businessName",
    WRITING_NUMBER = "writingNumber",
    AGENCY_NUMBER = "agencyNumber",
    IS_ACTIVE = "isActive",
    CREATED_ON = "createdOn",
    LAST_LOGIN_ON = "lastLoginOn",
}

export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 20;

export const AGENT_STATUS_COLORS = {
    active: "#3EAE54",
    inactive: "#E53935",
} as const;

export const DEFAULT_AGENTS_COUNT: IAgentsCountWithSegregationResp = {
    totalAgents: 0,
    activeAgents: 0,
    inactiveAgents: 0,
};

export const DEFAULT_AGENT_PERMISSIONS: IAgentsPermissionResp = {
    canEditAgent: false,
    canCreateDownline: false,
    canSyncContactsWithSendGrid: false,
    canSyncUserDataToHelpDesk: false,
    canResendInviteToAgent: false,
};

export const AGENTS_TBL_FIXED_COLS = ["Created On", "Status"] as const;

export const AGENTS_COLUMNS_NOT_TO_SHOW_INITIALLY = [] as const;

export const AGENTS_TBL_ALL_COLUMN_TITLES = [
    "Created On",
    "Status",
    "Name",
    "Email",
    "Cell Number",
    "User Type",
    "Business Name",
    "Writing Number",
    "Agency Number",
    "Last Login",
] as const;

export const AGENTS_TBL_DEFAULT_VISIBLE_COLS = AGENTS_TBL_ALL_COLUMN_TITLES.filter(
    (title) => !AGENTS_COLUMNS_NOT_TO_SHOW_INITIALLY.includes(title as (typeof AGENTS_COLUMNS_NOT_TO_SHOW_INITIALLY)[number])
);

export const AGENTS_FIXED_LEFT_DATA_KEYS = new Set<AgentsTblKeys>([
    AgentsTblKeys.CREATED_ON,
    AgentsTblKeys.IS_ACTIVE,
]);

export const AGENTS_ROUTE = "/agents";
export const AGENTS_EDIT_ROUTE = "/agents/agent";
export const EDIT_AGENT_QUERY_PARAM = "userId";
export const EDIT_AGENT_TAB_QUERY_PARAM = "tab";

export const AGENT_PRODUCTS_SAVE_SCOPE: AgentDetailContractSubScope = {
    section: AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION,
    subField: "agentProductDetails",
};

export const AGENT_LICENSED_STATES_SAVE_SCOPE: AgentDetailContractSubScope = {
    section: AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION,
    subField: "licensedStates",
};

export const AGENT_ACTION_BUTTON_FIELDS = {
    CREATE_DOWNLINE: "canCreateDownline",
    RESEND_INVITE: "canResendInviteToAgent",
} as const;

export const AGENT_ACTION_BUTTON_TOOLTIPS = {
    CREATE_DOWNLINE: "Create Downline",
    CREATE_DOWNLINE_DISABLED: "Downline not allowed for agents",
    RESEND_INVITE: "Resend Invite",
} as const;

export const AGENT_ACTION_ICON_COLORS = {
    ENABLED: "#000000",
    DISABLED: "#B0B0B0",
} as const;

export const DEFAULT_CARRIER_NAME = "FLA";

export const NO_AVAILABLE_PRODUCTS_AND_COMMISSIONS_FOUND = "No available products and commissions found";
